<template>
  <div class="row">
    <div class="col-12">
      <enterprise-edit-career-expo
        ref="editBooth"
        @booths:changed="updateCareerExpoSubtotal"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import EnterpriseEditCareerExpo from '../common/EnterpriseEditCareerExpo'
import { campusRecruitingValidations } from './enrollment-process-validations'
export default {
  name: 'EnrollmentProcessCareerExpo',
  components: {
    EnterpriseEditCareerExpo
  },
  mixins: [validationMixin],
  data () {
    return {
      currentExpoData: {}
    }
  },
  validations: campusRecruitingValidations,
  methods: {
    ...mapActions('pages/enterprises', [
      'updateOrder'
    ]),
    reset () {
      this.$refs.editBooth.resetBoothQuantity()
    },
    updateCareerExpoSubtotal (careerExpo) {
      this.currentExpoData = Object.assign({}, this.currentExpoData, careerExpo)
    },
    saveToStore () {
      this.updateOrder({
        careerExpo: this.currentExpoData
      })
    }
  }
}
</script>
